import React from 'react';
import PropTypes from 'prop-types';
import AppBar from './components/Appbar'
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {SidebarData} from '../UserNav/components/sidebarData'
import {WorkersData} from '../UserNav/components/Data/workers'
import {Link} from 'react-router-dom'
import Home from './pages/Home'
import Invoices from './pages/invoices'
import Driver from './pages/driver'
import Caregiver from './pages/Caregiver'
import PostDetails from './pages/CareGiver/careGiverDetails'
import Appbar from './components/Appbar'
import Sidemenu from "./components/sidemenu"
import GooglFceIcon from '../mystuff/Auth/vticon.png'

import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function ResponsiveDrawer(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>

<ListItem style={{margin:"20px 0"}}  button key="1">
      <img src={GooglFceIcon} alt="title" style={{height:"40px", width:"40px"}}></img>
      <p style={{margin:"0 0 0 10px"}}><strong>VT Exquisite Home Care</strong></p>
      </ListItem>
      {/* <div className={classes.toolbar} /> */}
     
      <Divider />
      <List>
        {SidebarData.map((text, index) => (
          <Link to={text.path}>
          <ListItem button key={text}>
          
            <ListItemIcon>{text.icon}</ListItemIcon>
            <ListItemText primary={text.title} />
           
          </ListItem>
          </Link>
        ))}
      </List>
      <Divider />
      <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Router>
    <div className={classes.root}>
      <CssBaseline />
      <AppBar/>
       
    
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
        <Route path="/login-page/Home" exact component={Home}/>
        <Route path="/login-page/driver"component={Driver}/>
        <Route path="/login-page" exact component={Home}/>
        <Route path="/login-page" exact component={Caregiver}/>
        <Route path="/login-page" exact component={Home}/>
        <Route path="/login-page/invoices"component={Invoices}/>
        <Route path="/login-page/caregiver"component={Caregiver}/>
        <Route path="/login-page/:id"  component={PostDetails} />
      </Switch>
      </main>
    </div>
    </Router>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;


